// We no longer replace this file during build via Angular.json's `fileReplacements` array
// since the dockerization/containerization of this app results in a single build for all environments.
// So, it now just holds global config information (or a global spot to stash some)

export const environment = {
	apiBaseURL: `${window.location.origin}/api/v1`,
	apiInfo: null, // retrieved from the server and set during main.ts initialization
};
